import { gql } from '@apollo/client/core';

export const SUSPEND_STUDENT = gql`
  mutation SuspendStudent($model: ManageStudentInput) {
    Teacher {
      SuspendAndActiveStudent(model: $model) {
        Result
      }
    }
  }
`;
